mainApp.component('constraintViewer', {
    templateUrl: '/public/components/discovery/rule-ref/constraint-viewer.component.html',
    bindings: {
        item: '<'
    },
    controller: function($state) {
        const ctrl = this;

        ctrl.$onInit = function() {
            ctrl.fetchServiceNames();
        }

        ctrl.fetchServiceNames = function() {
            store.fetch({
                path: '/apps?accountId=' + $state.params.accountId,
                success: function (data) {
                    ctrl.servicesNames = {};
                    for (let key in data) {
                        ctrl.servicesNames[data[key].id] = data[key].display_name;
                    }
                },
            });
        }
    },
});